<ng-container *transloco="let t">
  @for (sarskiltVillkor of sarskildaVillkor; track $index) {
    <p class="fw-bold sarskilt-villkor-header">
      {{ t('sarskilda_villkor_header') }} {{ $index + 1 }}
    </p>
    <p class="sarskilt-villkor-text">
      {{
        question().translations?.list[sarskiltVillkor.id]
          | translate: activeLang() : sarskiltVillkor.text
      }}
    </p>
    @if (comments()) {
      <div class="comment">
        <lib-input-container
          [label]="t('sarskilda_villkor_comment_label')"
          [required]="false"
          [maxLength]="1500"
          [currentLength]="comments()[$index].value?.length ?? 0"
          [for]="question().id + '_' + sarskiltVillkor.id"
          [errorText]="
            comments()[$index].invalid ? t('validation_maxlength') : undefined
          "
        >
          @if (readOnly()) {
            <div [class.invalid]="comments()[$index].invalid">
              <div
                class="readonly"
                [ngClass]="
                  commentsReadonly[$index]()?.length < 700
                    ? commentsReadonly[$index]()?.length < 300
                      ? 'small-height'
                      : 'medium-height'
                    : ''
                "
              >
                <span>
                  {{ commentsReadonly[$index]() }}
                </span>
              </div>
            </div>
          } @else {
            <textarea
              vinnova-textarea
              [id]="question().id + '_' + sarskiltVillkor.id"
              [required]="false"
              [formControl]="comments()[$index]"
              size="large"
            ></textarea>
          }
        </lib-input-container>
      </div>
    }
  } @empty {
    <p class="fw-bold sarskilt-villkor-header">
      {{ t('sarskilda_villkor_missing_header') }}
    </p>
    <p>{{ t('sarskilda_villkor_missing_text') }}</p>
  }
  <p class="fw-bold sarskilt-villkor-header">
    {{ t('sarskilda_villkor_anvisningar_header') }}
  </p>
  <p>
    {{
      anvisningarRekommendationer
        ? (question().translations?.list['anvisningarRekommendationer']
          | translate: activeLang() : anvisningarRekommendationer)
        : t('sarskilda_villkor_anvisningar_missing_text')
    }}
  </p>
</ng-container>
